<template>
    <Sidebar />
    <Content class="analytics-content analytics-big-box">
        <div class="inner inner-box">
            <div style="height:100%">
                <AnalyticsHeader v-if="$store.state.user_data && $store.state.user_data.merchant_account_id" :key="any_head_key"/>    
                <div class="main">
                    
                    <CollectionList v-if="$store.state.user_data.merchant_account_id && can_start" :date_range="{ start_date:start_date, end_date:end_date }" :key="coll_key"/>
                    
                </div>
            </div>
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import AnalyticsHeader from '@/components/analytics/AnalyticsHeader.vue';
import CollectionList from '@/components/creator/CollectionList.vue';
import Content from '@/components/ui/Content.vue';
import moment from 'moment';
import { handleMaxMinFun } from '@/utils/SwitchFun.js';

export default {
    name: 'Analytics - Products',

    data() {
        return {
            start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
            end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
            coll_key: 0,
            can_start:false,//阻止有些元件在時間整理完之前出現
        }
    },

    watch: {
        '$store.state.user_data.merchant_account_id': function (val) {
            this.startFunction();
        },
    },

    components: {
        Sidebar,
        Scrollbar,
        AnalyticsHeader,
        CollectionList,
        Content,
    },

    methods:{
        startFunction(){
            let checkTime = handleMaxMinFun( this.start_date, this.end_date ,this);
            this.start_date = checkTime[0];
            this.end_date= checkTime[1];
            this.can_start=true;
        },
    },

    mounted(){
        if(!this.$store.state.user_data.permission_list.analytics.viewPerformanceSummaries.permission){
            this.$router.push('/creator/list');
            return;
        }
        this.startFunction();
        this.EventBus.off('update-date');
        this.EventBus.on('update-date', (obj) => {
            this.start_date = obj.start_date;
            this.end_date = obj.end_date;
            this.current_page=1;

            setTimeout(() => {
                this.coll_key+=1;
            }, 10);
        });
    }

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.analytics-content {

    .inner {
        height: 100%;
        padding: 24px 48px; //24px 24px 0 24px;

        .main{
            height: calc(100% - 64px);
        }

    }

    .collections .inner{
        padding: unset;

        .title-content  {
            max-width:unset !important;
        }
    }

    .data-list{
        max-height: calc(95vh - 200px);
        thead{
            position: sticky;
            top: 0;
            z-index: 10;
            background: var(--white);
        }
    }
}
</style>